import {
  DeliveryOption,
  DeliveryOptions,
} from "./DeliveryOptions/DeliveryOptions";
import { ProductDeliveryReturns } from "./ProductDeliveryReturns/ProductDeliveryReturns";
import { ExtendedReturnsPolicy } from "./ExtendedReturnsPolicy/ExtendedReturnsPolicy";
import { Trigger } from "../__shared__/Trigger/Trigger";
import { SEOFriendlyDrawer } from "../__shared__/SEOFriendlyDrawer/SEOFriendlyDrawer";
import { useState } from "react";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

export const PRODUCT_DELIVERY_OPTIONS_ACCORDION_INSTANCE_NAME =
  "product-delivery-options";
export type ReturnsDateObj = Record<"year" | "month" | "date", number>;
export type Props = {
  deliveryOptions: DeliveryOption[];
  skuId: string;
  isAvailableToOrderOrPreorder: boolean;
  stockApiBaseUrl: string;
  stockApiKey: string;
  showExtendedReturnsMessaging: boolean;
  extendedReturnsDates: {
    startDate: string;
    endDate: string;
    deadlineDate: string;
  };
  isRetired: boolean;
  isInStoreOnly: boolean;
  isMeteredProduct?: boolean;
  isM2M: boolean;
  browsePageHierarchy: Array<{ categoryId: string }>;
  sellingProductType?: string;
  showOutletReturnMessage?: boolean;
  isBladedArticle?: boolean;
  showChristmasDeliveryMessaging: boolean;
};

export function ProductDeliveryOptionsSideDrawerUI({
  deliveryOptions,
  skuId,
  isAvailableToOrderOrPreorder,
  stockApiBaseUrl,
  stockApiKey,
  showExtendedReturnsMessaging,
  extendedReturnsDates,
  isInStoreOnly,
  isRetired,
  isMeteredProduct,
  isM2M,
  browsePageHierarchy,
  sellingProductType = "",
  showOutletReturnMessage = false,
  isBladedArticle = false,
  showChristmasDeliveryMessaging,
}: Props) {
  const [open, setOpen] = useState(false);

  if (isRetired) return null;
  if (isInStoreOnly) return null;

  return (
    <>
      <Trigger
        label="Delivery and returns"
        onClick={withSideDrawerAnalytics("Delivery & Returns", () =>
          setOpen(true),
        )}
      />
      <SEOFriendlyDrawer
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        heading="Delivery and returns"
        primaryButtonText="Close"
      >
        {deliveryOptions.length > 0 && (
          <DeliveryOptions
            skuId={skuId}
            isAvailableToOrderOrPreorder={isAvailableToOrderOrPreorder}
            deliveryOptions={deliveryOptions}
            stockApiBaseUrl={stockApiBaseUrl}
            stockApiKey={stockApiKey}
          />
        )}
        <ProductDeliveryReturns
          browsePageHierarchy={browsePageHierarchy}
          sellingProductType={sellingProductType}
          showOutletReturnsMessage={showOutletReturnMessage}
          isBladedArticle={isBladedArticle}
          isM2M={isM2M}
          returnsStartDate={extendedReturnsDates.startDate}
          returnsEndDate={extendedReturnsDates.endDate}
          isMeteredProduct={isMeteredProduct}
          showChristmasDeliveryMessaging={showChristmasDeliveryMessaging}
        />
        {showExtendedReturnsMessaging && (
          <ExtendedReturnsPolicy {...extendedReturnsDates} />
        )}
      </SEOFriendlyDrawer>
    </>
  );
}
